module.exports = __webpack_public_path__ + "static/media/fly0037.29776c21.webp";